<template>
  <div class="point-view">
    <!-- 账套设置 -->
    <div class="point-view-101" v-if="data.id == 101">
      <div
        class="point-view-item"
        :class="{ 'is-error': item.isCorrect == 0 }"
        v-for="(item, index) of data.data"
        :key="index"
      >
        <pointText class="point-view-line" tag="div" label="账套名称" :value="item.companyName" />
        <pointText
          class="point-view-line"
          tag="div"
          label="会计准则"
          :value="getLabel(item.accountingStandard, accounting_standards)"
        />
        <pointText class="point-view-line" tag="div" label="账套启用年月" :value="item.enableDate" />
        <pointText
          class="point-view-line"
          tag="div"
          label="增值税种类"
          :value="getLabel(item.vatType, vatTypeOptions)"
        />
        <pointText
          class="point-view-line"
          tag="div"
          label="统一社会信用代码"
          :value="item.creditCode"
        />
      </div>
    </div>
    <!-- 凭证录入 -->
    <div class="point-view-201" v-if="data.id == 201">
      <div
        class="point-view-item"
        :class="{ 'is-error': item.isCorrect == 0 }"
        v-for="(item, index) of data.data"
        :key="index"
      >
        <div
          v-for="(voucherItem, voucherIndex) of item.voucherList"
          :key="voucherIndex"
          class="point-view-line"
        >
          <pointText label="科目编码" :value="voucherItem.subjectCode" />
          <pointText label="科目名称" :value="voucherItem.subjectName" />
          <pointText label="借方金额" :value="voucherItem.debitMoney" />
          <pointText label="贷方金额" :value="voucherItem.creditMoney" />
          <pointText label="数量" :value="voucherItem.num" />
          <pointText label="单价" :value="voucherItem.price" />

          <template v-for="auxiliaryItem of voucherItem.auxiliary || []">
            <pointText
              :label="`辅助核算${auxiliaryItem.accountingCategoryName}名称`"
              :value="auxiliaryItem.name"
            />
            <pointText
              :label="`辅助核算${auxiliaryItem.accountingCategoryName}编码`"
              :value="auxiliaryItem.code"
            />
          </template>
        </div>

        <pointText class="point-view-line" tag="div" label="凭证字" :value="item.word" />
        <pointText class="point-view-line" tag="div" label="业务单据时间" :value="item.voucherDate" />
        <pointText class="point-view-line" tag="div" label="制单人姓名" :value="item.realName" />
        <pointText class="point-view-line" tag="div" label="附单据数量" :value="item.receiptNum" />
      </div>
    </div>
    <!-- 科目期初设置 -->
    <div class="point-view-301" v-if="data.id == 301">
      <div
        class="point-view-item point-view-line"
        :class="{ 'is-error': item.isCorrect == 0 }"
        v-for="(item, index) of data.data"
        :key="index"
      >
        <pointText label="会计科目编码" :value="item.code" />
        <pointText label="会计科目名称" :value="item.name" />
        <pointText label="期初余额" :value="item.initialBalance" />
        <pointText label="借贷方向" :value="item.balanceDirection" />
        <pointText label="本年累计借方" :value="item.cumulativeDebit" />
        <pointText label="本年累计贷方" :value="item.cumulativeCredit" />
        <pointText label="年初余额" :value="item.beginningBalance" />
        <pointText
          label="辅助核算"
          :value="(item.auxiliaryCategories || []).join('，')"
        />
        <pointText label="数量核算单位" :value="item.unit" />
      </div>
    </div>
    <!-- 辅助核算 -->
    <div class="point-view-302" v-if="data.id == 302">
      <div
        class="point-view-item point-view-line"
        :class="{ 'is-error': item.isCorrect == 0 }"
        v-for="(item, index) of data.data"
        :key="index"
      >
        <pointText label="辅助核算项" :value="item.accountingCategoryName" />
        <pointText
          :label="`${item.accountingCategoryName}编码`"
          :value="item.code"
        />
        <pointText
          :label="`${item.accountingCategoryName}名称`"
          :value="item.name"
        />
      </div>
    </div>
    <!-- 余额表 -->
    <div class="point-view-401" v-if="data.id == 401">
      <div
        class="point-view-item point-view-line"
        :class="{ 'is-error': item.isCorrect == 0 }"
        v-for="(item, index) of data.data"
        :key="index"
      >
        <pointText label="会计期间" :value="(item.period || []).join('至')" />
        <pointText label="科目名称" :value="item.subjectName" />
        <pointText label="科目编码" :value="item.subjectCode" />
        <pointText
          label="借方期初余额"
          :value="item.openingDebitBalanceMoney"
        />
        <pointText
          label="贷方期初余额"
          :value="item.openingCreditBalanceMoney"
        />
        <pointText label="借方本期发生额" :value="item.debitAmountMoney" />
        <pointText label="贷方本期发生额" :value="item.creditAmountMoney" />
        <pointText
          label="借方期末余额"
          :value="item.closingDebitBalanceMoney"
        />
        <pointText
          label="贷方期末余额"
          :value="item.closingCreditBalanceMoney"
        />
      </div>
    </div>
    <!-- 结账 -->
    <div class="point-view-501" v-if="data.id == 501">
      <div
        class="point-view-item point-view-line"
        :class="{ 'is-error': item.isCorrect == 0 }"
        v-for="(item, index) of data.data"
        :key="index"
      >
        <pointText label="结账期间" :value="item.closeMonth" />
      </div>
    </div>
  </div>
</template>

<script setup>
import pointText from "./pointText.vue";
const { proxy } = getCurrentInstance();

//获取字典
const {
  accounting_standards, //会计准则
} = proxy.useDict("accounting_standards");

// 增值税种类
const vatTypeOptions = [
  { label: "小规模纳税人", value: 0 },
  { label: "一般纳税人", value: 1 },
];

const props = defineProps({
  data: {
    type: Object,
    default: () => {},
  },
});

function getLabel(value, options = []) {
  const option = options.find((item) => item.value == value);

  return (option && option.label) || "";
}
</script>

<style lang="scss" scoped>
.point-view {
  text-align: left;
  line-height: 1.5;

  .is-error {
    color: #f56c6c;
  }

  .point-view-item {
    & + .point-view-item {
      margin-top: 6px;
    }
  }
}
</style>
